import React from 'react';
import type { AfcSubmission } from '@axiom/validation';

import bannerBackgroundImg from '../../../assets/graphics/textured_dark_background.webp';
import { DarkTheme } from '../../theme/DarkTheme/DarkTheme';
import { Layout } from '../../layout/Layout/Layout';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Grid } from '../../layout/Grid/Grid';
import { GridRow } from '../../layout/Grid/GridRow';
import { GridColumn } from '../../layout/Grid/GridColumn';
import { AxiomLogo } from '../../element/AxiomLogo/AxiomLogo';
import { LargeHeader } from '../../content/LargeHeader/LargeHeader';

export const SubmissionPdfHeader = ({
  submission,
}: {
  submission: AfcSubmission;
}) => {
  return (
    <DarkTheme>
      <Layout
        name="SUBMISSION_HEADER"
        background={{
          color: 'panelDark',
          image: bannerBackgroundImg,
          repeat: 'no-repeat',
          position: 'center top',
        }}
      >
        <Gutter top="40px" bottom="24px" horizontal="24px">
          <Grid>
            <GridRow>
              <GridColumn>
                <Gutter bottom="16px">
                  <AxiomLogo name="LOGO" height="47px" />
                </Gutter>
              </GridColumn>
            </GridRow>
            <GridRow gutterBottom="16px">
              <GridColumn>
                <LargeHeader name="COMPANY_NAME">
                  {submission.jobName}
                </LargeHeader>
              </GridColumn>
            </GridRow>
          </Grid>
        </Gutter>
      </Layout>
    </DarkTheme>
  );
};
